<script setup lang="ts">
const { logoUrl, name } = defineProps<{
  logoUrl: string
  name?: string
}>()

const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <img
    :src="logoUrl"
    :data-nui-tooltip="name"
    :alt="t('alt', { name })"
  >
</template>

<i18n lang="json">
{
  "en": {
    "alt": "Logo of {name}"
  },
  "nl": {
    "alt": "Logo van {name}"
  }
}
</i18n>
